import React from 'react';

export const SalesPriceColumnFormatter = (cellContent, row) => (
  <>{row.SalesPrice}</>
);

export const PurchasePriceColumnFormatter = (cellContent, row) => (
  <>{row.PurchasePrice}</>
);
